import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown-box" }
const _hoisted_2 = { class: "dropdown-box__label" }

import DropdownStandard, { optionType } from '@/design-system/molecules/DropdownStandard.vue'
import { computed, toRefs } from 'vue'
import { getRealmId } from '@/utils/realmId'
import { useI18n } from 'vue-i18n'
import { ComplexProperties, Nullable } from '../../../types'

interface Props {
  complexes: ComplexProperties[]
  selectedComplex?: Nullable<ComplexProperties>
  optionsWithData?: Set<string | null>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardDropdownFilterComplex',
  props: {
    complexes: {},
    selectedComplex: { default: undefined },
    optionsWithData: { default: undefined }
  },
  emits: ["selectionChanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { complexes, selectedComplex } = toRefs(props)

const { t } = useI18n()

const emits = __emit

function getTitle(): string {
  const realmId = getRealmId()
  if (realmId === 'akademiskahus') {
    return t('title__complex__campus')
  }
  return t('general__title__complex')
}

const searchType = computed<string>(() => getTitle().toLowerCase())
const label = computed<string>(() => getTitle())

const title = computed<string>(() => {
  if (disabled.value) {
    return ''
  }
  if (!hasSelections.value) {
    return t('general__text__select') + ' ' + getTitle().toLowerCase()
  }
  if (selectedComplex.value) {
    return selectedComplex.value.title
  }
  return ''
})

const hasSelections = computed<boolean>(() => {
  return options.value.findIndex((x) => x.selected) != -1
})

const disabled = computed<boolean>(() => {
  if (options.value.length === 0) {
    return true
  }
  if (options.value.every((entry) => entry.disabled)) {
    return true
  }
  return false
})

const options = computed<optionType[]>(() => {
  if (!complexes.value) {
    return []
  }

  const selectAll: optionType = {
    id: 'complex_all',
    disabled: false,
    name: t('general__data__dashboard_no_selection'),
    selected: false,
    subtitle: '',
    value: []
  }

  const complexOptions: optionType[] = complexes.value.map(complexToOption)
  complexOptions.sort(sortOption)
  return [selectAll, ...complexOptions]
})

function select(id: string) {
  if (id === 'complex_all') {
    emits('selectionChanged', undefined)
    return
  }
  const complex = complexes.value.find((x) => x.belongsToId === id)
  emits('selectionChanged', complex)
}

function complexToOption(complex: ComplexProperties): optionType {
  const selected = complex.belongsToId === selectedComplex?.value?.belongsToId
  const disabled = !selected && shouldBeDisabled(complex)
  const subtitle =
    selected && shouldBeDisabled(complex) ? t('general__data__data-missing') : undefined
  return {
    id: complex.belongsToId,
    name: complex.title,
    value: [],
    selected,
    disabled,
    subtitle
  }
}

function shouldBeDisabled(complex: ComplexProperties): boolean {
  if (props.optionsWithData) {
    return !props.optionsWithData.has(complex.belongsToId)
  }
  return false
}

function sortOption(a: optionType, b: optionType) {
  if (a.disabled === b.disabled) {
    return a.name.localeCompare(b.name)
  }
  return a.disabled < b.disabled ? -1 : 1
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(label.value), 1),
    _createVNode(DropdownStandard, {
      hasSearch: true,
      options: options.value,
      searchType: searchType.value,
      title: title.value,
      onSelect: select
    }, null, 8, ["options", "searchType", "title"])
  ]))
}
}

})